const LoadingAuthComponent = () => {
	return <h1>...Cargando</h1>
}

export default LoadingAuthComponent
